// src/api/workerAPI.js
import axios from 'axios';

const workerAPI = axios.create({
  baseURL: 'https://missionmap-lc.onrender.com/api/workers', // adjust this if your route differs
});

workerAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // JWT from localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default workerAPI;
